export default "__VITE_ASSET__DtRusH9H__"